export default "/images/topdanmark-min-org.png?291c3558817c28a1ee5200a92d6adbe0";